/* 
uiFlags.ts is used in minasidor-app to determine which of the questions has been answered.
If the fllows are updated, don't forget to also update uiFlags.ts.
*/
import { Flow } from 'src/app/services/flow.service';

export const initialScreensFlow: Flow = {
  questions: [
    { path: '/basic-info' },
    { path: '/monthly-sales' },
    { path: '/high-amount-for-turnover' },
    { path: '/init-app' }
  ],
  extra: []
};

export const fullFlow: Flow = {
  initialScreen: { path: '/start-improve' },
  questions: [
    { path: '/purpose', blockTitle: 'summary.reasonAndGuarantor' },
    { path: '/guarantor' },
    { path: '/accounting-upload', blockTitle: 'summary.financialInfo.title' },
    { path: '/account-data' },
    { path: '/iban' },
    { path: '/channel', blockTitle: 'summary.other.title' },
  ],
  extra: [
    { path: '/monthly-sales', blockTitle: 'summary.monthlySales.title' },
  ]
};

export const fastTrackFlow: Flow = {
  initialScreen: { path: '/start-improve' },
  questions: [
    { path: '/purpose', blockTitle: 'summary.reasonAndGuarantor' },
    { path: '/guarantor' },
    { path: '/iban', blockTitle: 'summary.financialInfo.title' },
    { path: '/channel', blockTitle: 'summary.other.title' },
  ],
  extra: [
    { path: '/monthly-sales', blockTitle: 'summary.monthlySales.title' },
  ]
};

export const bigInitialFlow: Flow = {
  questions: [],
  extra: []
};

export const bigFlow: Flow = {
  questions: [],
  extra: []
};

export const tmSignUpFlow: Flow = {
  questions: [],
  extra: []
}

export const tmAuthFlow: Flow = {
  questions: [],
  extra: []
}